import { render, staticRenderFns } from "./AtmoInfoPm10.vue?vue&type=template&id=cf11114c&scoped=true&"
var script = {}
import style0 from "./AtmoInfoPm10.vue?vue&type=style&index=0&id=cf11114c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf11114c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf11114c')) {
      api.createRecord('cf11114c', component.options)
    } else {
      api.reload('cf11114c', component.options)
    }
    module.hot.accept("./AtmoInfoPm10.vue?vue&type=template&id=cf11114c&scoped=true&", function () {
      api.rerender('cf11114c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/integrations/templates/AtmoInfoPm10.vue"
export default component.exports